import {
	IsNotEmpty,
	IsPositive,
	IsString,
	IsUUID,
	IsInt,
	ValidateNested,
	IsArray,
	IsOptional,
	ArrayMaxSize,
	ArrayMinSize,
} from 'class-validator';
import { FileDto } from './file.dto';
import { ChallengeDto } from './challenges.dto';
import { CreateChallengeDayDto } from './challenges-day.dto';
import { Type } from 'class-transformer';

export class ChallengeWeekDto {
	public id: string;
	public challengeId: string;
	public sequence: number;
	public titleMarkdown: string;
	public descriptionMarkdown: string;
	public goal: string;
	public mediaFileId?: string;
	public startDate: Date;

	public createdAt: Date;
	public updatedAt: Date;
	public deletedAt?: Date;

	public challenge?: ChallengeDto;
	public mediaFile?: FileDto;
}

export class CreateChallengeWeekDto {
	@IsOptional()
	@IsUUID()
	public mediaFileId?: string;

	@IsNotEmpty()
	@IsInt()
	@IsPositive()
	public sequence: number;

	@IsNotEmpty()
	@IsString()
	public titleMarkdown: string;

	@IsNotEmpty()
	@IsString()
	public descriptionMarkdown: string;

	@IsNotEmpty()
	@IsString()
	public goal: string;

	@IsArray()
	@ArrayMinSize(7)
	@ArrayMaxSize(7)
	@ValidateNested({ each: true })
	@Type(() => CreateChallengeDayDto)
	public days: CreateChallengeDayDto[];
}
